import { MAT_SELECT_CONFIG } from '@angular/material/select';

const EFFY_MATERIAL_SELECT_CONFIG = {
    hideSingleSelectionIndicator: true,
};
const provideEffyMaterialSelect = { provide: MAT_SELECT_CONFIG, useValue: EFFY_MATERIAL_SELECT_CONFIG };

/**
 * Generated bundle index. Do not edit.
 */

export { EFFY_MATERIAL_SELECT_CONFIG, provideEffyMaterialSelect };
